<template>
	<div
		class="g-block-title-basic g-block-title-padding"
		:class="{
			'g-block-title-basic--edit': editable,
			'is-active': editable && active,
			'g-block-title-basic--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<RichTextEditable
			v-if="editable"
			class="g-block-title-basic__text"
			:model-value="data.content"
			placeholder="请输入标题"
			@update:model-value="onContentUpdate"
			@focus="onWrapClick"
		/>
		<div
			v-else
			class="g-block-title-basic__text"
			v-html="data.content || ''"
		></div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';

	export default {
		name: 'GBlockTitleBasic',
		components: { RichTextEditable },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select', 'update'],
		methods: {
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onContentUpdate(content) {
				this.$emit('update', { content });
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-title-basic {
		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-basic__text {
		display: block;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-weight: 600;
		color: #333;
		line-height: 1.2;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;

		:deep(.g-rich-text-editable__content) {
			line-height: 1.2;
			min-height: unset;
		}

		:deep(span),
		:deep(font) {
			line-height: 1.2;
			vertical-align: middle;
		}
	}

	.g-block-title-basic--h5 .g-block-title-basic__text {
		font-size: 0.36rem;
	}
</style>
